import { jsx as _jsx } from "react/jsx-runtime";
import { TabComponent } from "../SharedComponents/TabComponent";
import { useGetTabNameAndValue } from "../hooks/useGetTabNameAndValue";
export const UpdateDeliveryModal_ContentComponent = (props) => {
    const { tabName } = useGetTabNameAndValue();
    return _jsx(TabComponent, Object.assign({}, props, { tabName: tabName }));
};
